/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as ConfigurationRouteImport } from './routes/configuration'
import { Route as DataQualityRouteImport } from './routes/data-quality'
import { Route as EnergyEfficiencyRouteImport } from './routes/energy-efficiency'
import { Route as EquipmentPerformanceRouteImport } from './routes/equipment-performance'
import { Route as FindingsRouteImport } from './routes/findings'
import { Route as IndoorConditionsRouteImport } from './routes/indoor-conditions'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RecommendationsRouteImport } from './routes/recommendations'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as SavingsPotentialRouteImport } from './routes/savings-potential'
import { Route as TeamRouteImport } from './routes/team'
import { Route as TrendRouteImport } from './routes/trend'
import { Route as AdminKnowledgeBaseRouteImport } from './routes/admin/knowledge-base'
import { Route as BuildingsBuildingIdRouteImport } from './routes/buildings/$buildingId'
import { Route as BuildingsBuildingIdZonesZoneIdRouteImport } from './routes/buildings/$buildingId.zones.$zoneId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationRoute = ConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const DataQualityRoute = DataQualityRouteImport.update({
  id: '/data-quality',
  path: '/data-quality',
  getParentRoute: () => rootRouteImport,
} as any)
const EnergyEfficiencyRoute = EnergyEfficiencyRouteImport.update({
  id: '/energy-efficiency',
  path: '/energy-efficiency',
  getParentRoute: () => rootRouteImport,
} as any)
const EquipmentPerformanceRoute = EquipmentPerformanceRouteImport.update({
  id: '/equipment-performance',
  path: '/equipment-performance',
  getParentRoute: () => rootRouteImport,
} as any)
const FindingsRoute = FindingsRouteImport.update({
  id: '/findings',
  path: '/findings',
  getParentRoute: () => rootRouteImport,
} as any)
const IndoorConditionsRoute = IndoorConditionsRouteImport.update({
  id: '/indoor-conditions',
  path: '/indoor-conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RecommendationsRoute = RecommendationsRouteImport.update({
  id: '/recommendations',
  path: '/recommendations',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const SavingsPotentialRoute = SavingsPotentialRouteImport.update({
  id: '/savings-potential',
  path: '/savings-potential',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const TrendRoute = TrendRouteImport.update({
  id: '/trend',
  path: '/trend',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKnowledgeBaseRoute = AdminKnowledgeBaseRouteImport.update({
  id: '/admin/knowledge-base',
  path: '/admin/knowledge-base',
  getParentRoute: () => rootRouteImport,
} as any)
const BuildingsBuildingIdRoute = BuildingsBuildingIdRouteImport.update({
  id: '/buildings/$buildingId',
  path: '/buildings/$buildingId',
  getParentRoute: () => rootRouteImport,
} as any)
const BuildingsBuildingIdZonesZoneIdRoute =
  BuildingsBuildingIdZonesZoneIdRouteImport.update({
    id: '/zones/$zoneId',
    path: '/zones/$zoneId',
    getParentRoute: () => BuildingsBuildingIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/chat': typeof ChatRoute
  '/configuration': typeof ConfigurationRoute
  '/data-quality': typeof DataQualityRoute
  '/energy-efficiency': typeof EnergyEfficiencyRoute
  '/equipment-performance': typeof EquipmentPerformanceRoute
  '/findings': typeof FindingsRoute
  '/indoor-conditions': typeof IndoorConditionsRoute
  '/login': typeof LoginRoute
  '/recommendations': typeof RecommendationsRoute
  '/reports': typeof ReportsRoute
  '/savings-potential': typeof SavingsPotentialRoute
  '/team': typeof TeamRoute
  '/trend': typeof TrendRoute
  '/admin/knowledge-base': typeof AdminKnowledgeBaseRoute
  '/buildings/$buildingId': typeof BuildingsBuildingIdRouteWithChildren
  '/buildings/$buildingId/zones/$zoneId': typeof BuildingsBuildingIdZonesZoneIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/chat': typeof ChatRoute
  '/configuration': typeof ConfigurationRoute
  '/data-quality': typeof DataQualityRoute
  '/energy-efficiency': typeof EnergyEfficiencyRoute
  '/equipment-performance': typeof EquipmentPerformanceRoute
  '/findings': typeof FindingsRoute
  '/indoor-conditions': typeof IndoorConditionsRoute
  '/login': typeof LoginRoute
  '/recommendations': typeof RecommendationsRoute
  '/reports': typeof ReportsRoute
  '/savings-potential': typeof SavingsPotentialRoute
  '/team': typeof TeamRoute
  '/trend': typeof TrendRoute
  '/admin/knowledge-base': typeof AdminKnowledgeBaseRoute
  '/buildings/$buildingId': typeof BuildingsBuildingIdRouteWithChildren
  '/buildings/$buildingId/zones/$zoneId': typeof BuildingsBuildingIdZonesZoneIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/chat': typeof ChatRoute
  '/configuration': typeof ConfigurationRoute
  '/data-quality': typeof DataQualityRoute
  '/energy-efficiency': typeof EnergyEfficiencyRoute
  '/equipment-performance': typeof EquipmentPerformanceRoute
  '/findings': typeof FindingsRoute
  '/indoor-conditions': typeof IndoorConditionsRoute
  '/login': typeof LoginRoute
  '/recommendations': typeof RecommendationsRoute
  '/reports': typeof ReportsRoute
  '/savings-potential': typeof SavingsPotentialRoute
  '/team': typeof TeamRoute
  '/trend': typeof TrendRoute
  '/admin/knowledge-base': typeof AdminKnowledgeBaseRoute
  '/buildings/$buildingId': typeof BuildingsBuildingIdRouteWithChildren
  '/buildings/$buildingId/zones/$zoneId': typeof BuildingsBuildingIdZonesZoneIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/chat'
    | '/configuration'
    | '/data-quality'
    | '/energy-efficiency'
    | '/equipment-performance'
    | '/findings'
    | '/indoor-conditions'
    | '/login'
    | '/recommendations'
    | '/reports'
    | '/savings-potential'
    | '/team'
    | '/trend'
    | '/admin/knowledge-base'
    | '/buildings/$buildingId'
    | '/buildings/$buildingId/zones/$zoneId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/chat'
    | '/configuration'
    | '/data-quality'
    | '/energy-efficiency'
    | '/equipment-performance'
    | '/findings'
    | '/indoor-conditions'
    | '/login'
    | '/recommendations'
    | '/reports'
    | '/savings-potential'
    | '/team'
    | '/trend'
    | '/admin/knowledge-base'
    | '/buildings/$buildingId'
    | '/buildings/$buildingId/zones/$zoneId'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/chat'
    | '/configuration'
    | '/data-quality'
    | '/energy-efficiency'
    | '/equipment-performance'
    | '/findings'
    | '/indoor-conditions'
    | '/login'
    | '/recommendations'
    | '/reports'
    | '/savings-potential'
    | '/team'
    | '/trend'
    | '/admin/knowledge-base'
    | '/buildings/$buildingId'
    | '/buildings/$buildingId/zones/$zoneId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  ChatRoute: typeof ChatRoute
  ConfigurationRoute: typeof ConfigurationRoute
  DataQualityRoute: typeof DataQualityRoute
  EnergyEfficiencyRoute: typeof EnergyEfficiencyRoute
  EquipmentPerformanceRoute: typeof EquipmentPerformanceRoute
  FindingsRoute: typeof FindingsRoute
  IndoorConditionsRoute: typeof IndoorConditionsRoute
  LoginRoute: typeof LoginRoute
  RecommendationsRoute: typeof RecommendationsRoute
  ReportsRoute: typeof ReportsRoute
  SavingsPotentialRoute: typeof SavingsPotentialRoute
  TeamRoute: typeof TeamRoute
  TrendRoute: typeof TrendRoute
  AdminKnowledgeBaseRoute: typeof AdminKnowledgeBaseRoute
  BuildingsBuildingIdRoute: typeof BuildingsBuildingIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration': {
      id: '/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof ConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-quality': {
      id: '/data-quality'
      path: '/data-quality'
      fullPath: '/data-quality'
      preLoaderRoute: typeof DataQualityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/energy-efficiency': {
      id: '/energy-efficiency'
      path: '/energy-efficiency'
      fullPath: '/energy-efficiency'
      preLoaderRoute: typeof EnergyEfficiencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/equipment-performance': {
      id: '/equipment-performance'
      path: '/equipment-performance'
      fullPath: '/equipment-performance'
      preLoaderRoute: typeof EquipmentPerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/findings': {
      id: '/findings'
      path: '/findings'
      fullPath: '/findings'
      preLoaderRoute: typeof FindingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/indoor-conditions': {
      id: '/indoor-conditions'
      path: '/indoor-conditions'
      fullPath: '/indoor-conditions'
      preLoaderRoute: typeof IndoorConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recommendations': {
      id: '/recommendations'
      path: '/recommendations'
      fullPath: '/recommendations'
      preLoaderRoute: typeof RecommendationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/savings-potential': {
      id: '/savings-potential'
      path: '/savings-potential'
      fullPath: '/savings-potential'
      preLoaderRoute: typeof SavingsPotentialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trend': {
      id: '/trend'
      path: '/trend'
      fullPath: '/trend'
      preLoaderRoute: typeof TrendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/knowledge-base': {
      id: '/admin/knowledge-base'
      path: '/admin/knowledge-base'
      fullPath: '/admin/knowledge-base'
      preLoaderRoute: typeof AdminKnowledgeBaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buildings/$buildingId': {
      id: '/buildings/$buildingId'
      path: '/buildings/$buildingId'
      fullPath: '/buildings/$buildingId'
      preLoaderRoute: typeof BuildingsBuildingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buildings/$buildingId/zones/$zoneId': {
      id: '/buildings/$buildingId/zones/$zoneId'
      path: '/zones/$zoneId'
      fullPath: '/buildings/$buildingId/zones/$zoneId'
      preLoaderRoute: typeof BuildingsBuildingIdZonesZoneIdRouteImport
      parentRoute: typeof BuildingsBuildingIdRoute
    }
  }
}

interface BuildingsBuildingIdRouteChildren {
  BuildingsBuildingIdZonesZoneIdRoute: typeof BuildingsBuildingIdZonesZoneIdRoute
}

const BuildingsBuildingIdRouteChildren: BuildingsBuildingIdRouteChildren = {
  BuildingsBuildingIdZonesZoneIdRoute: BuildingsBuildingIdZonesZoneIdRoute,
}

const BuildingsBuildingIdRouteWithChildren =
  BuildingsBuildingIdRoute._addFileChildren(BuildingsBuildingIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  ChatRoute: ChatRoute,
  ConfigurationRoute: ConfigurationRoute,
  DataQualityRoute: DataQualityRoute,
  EnergyEfficiencyRoute: EnergyEfficiencyRoute,
  EquipmentPerformanceRoute: EquipmentPerformanceRoute,
  FindingsRoute: FindingsRoute,
  IndoorConditionsRoute: IndoorConditionsRoute,
  LoginRoute: LoginRoute,
  RecommendationsRoute: RecommendationsRoute,
  ReportsRoute: ReportsRoute,
  SavingsPotentialRoute: SavingsPotentialRoute,
  TeamRoute: TeamRoute,
  TrendRoute: TrendRoute,
  AdminKnowledgeBaseRoute: AdminKnowledgeBaseRoute,
  BuildingsBuildingIdRoute: BuildingsBuildingIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
